module.exports = __webpack_public_path__ + "static/media/Chadwick4.f47cc988.jpg";